import * as React from "react";
const SvgFiRrJugBottle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.658 5.966 13 5.023V2a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2v3.178l-.755.283A5.02 5.02 0 0 0 2 10.143V19c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V9.912a3.99 3.99 0 0 0-3.342-3.946M20 9.911v5.588c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-6c0-.827.673-1.5 1.5-1.5.013 0 .023-.007.036-.007A1.99 1.99 0 0 1 20 9.911m-3 12.088H7c-1.654 0-3-1.346-3-3v-8.857c0-1.244.782-2.373 1.947-2.809l1.404-.526A1 1 0 0 0 8 5.87V1.999h3V5.87a1 1 0 0 0 .835.986l3.807.634a3.47 3.47 0 0 0-.643 2.009v6c0 1.93 1.57 3.5 3.5 3.5.539 0 1.044-.133 1.5-.351v.351c0 1.654-1.345 3-2.999 3"
    />
  </svg>
);
export default SvgFiRrJugBottle;
